import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSubscription } from '../../contexts/SubscriptionContext';
import './WelcomeToast.css';

const WelcomeToast = () => {
  const { t } = useTranslation();
  const { showWelcomeCreditsToast, dismissWelcomeCreditsToast } = useSubscription();
  const [isVisible, setIsVisible] = useState(false);
  const [isAnimatingOut, setIsAnimatingOut] = useState(false);

  const handleClose = useCallback(() => {
    setIsAnimatingOut(true);
    setTimeout(() => {
      setIsVisible(false);
      setIsAnimatingOut(false);
      dismissWelcomeCreditsToast();
    }, 400); // match transition duration
  }, [dismissWelcomeCreditsToast]);

  useEffect(() => {
    if (!showWelcomeCreditsToast) {
      setIsVisible(false);
      return;
    }

    const checkAndShow = () => {
      const needsAgeRange = sessionStorage.getItem('theychat-needs-age-range') === 'true';
      if (!needsAgeRange) {
        setIsVisible(true);
      }
    };

    // Check initially
    checkAndShow();

    // Listen for age range completed event to display welcome toast right after modal closes
    const handleAgeRangeCompleted = () => {
      setIsVisible(true);
    };

    window.addEventListener('age-range-completed', handleAgeRangeCompleted);
    return () => {
      window.removeEventListener('age-range-completed', handleAgeRangeCompleted);
    };
  }, [showWelcomeCreditsToast]);

  // Auto-dismiss timer only starts after the toast actually becomes visible to the user
  useEffect(() => {
    if (isVisible) {
      const timer = setTimeout(() => {
        handleClose();
      }, 10000); // 10 seconds display time

      return () => clearTimeout(timer);
    }
  }, [isVisible, handleClose]);

  if (!isVisible) return null;

  return (
    <div className={`welcome-toast-container ${isAnimatingOut ? 'slide-out' : 'slide-in'}`}>
      <div className="welcome-toast-content">
        <div className="welcome-toast-icon">✨</div>
        <div className="welcome-toast-text">
          <h4>{t('welcomeCredits.toastTitle')}</h4>
          <p>{t('welcomeCredits.toast', { count: 5 })}</p>
        </div>
        <button
          type="button"
          className="welcome-toast-close"
          onClick={handleClose}
          aria-label="Close"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default WelcomeToast;
